import { Utils } from '@genial/utils';

const getMaxValuePreChar = (value: number, maxValue: number) => {
  const isMaxValue = value === maxValue;
  if (!isMaxValue) {
    return '';
  }
  return '+ ';
};

export const labelTypesFormatted = {
  number: {
    min: (value: number) => {
      return value;
    },
    max: (value: number, maxValue: number) => {
      const maxValuePreChar = getMaxValuePreChar(value, maxValue);
      return `${maxValuePreChar}${value}`;
    },
  },
  money: {
    min: (value: number) => {
      return Utils.Mask.Money(value);
    },
    max: (value: number, maxValue: number) => {
      const maxValuePreChar = getMaxValuePreChar(value, maxValue);
      return `${maxValuePreChar}${Utils.Mask.Money(value)}`;
    },
  },
  percentage: {
    min: (value: number) => {
      return value === 0 ? '0%' : Utils.Mask.Percentage(value);
    },
    max: (value: number) => {
      return Utils.Mask.Percentage(value);
    },
  },
  months: {
    min: (value: number) => {
      return value;
    },
    max: (value: number, maxValue: number) => {
      const maxValuePreChar = getMaxValuePreChar(value, maxValue);
      return `${maxValuePreChar}${value} meses`;
    },
  },
  days: {
    min: (value: number) => {
      return value;
    },
    max: (value: number, maxValue: number) => {
      const maxValuePreChar = getMaxValuePreChar(value, maxValue);
      return `${maxValuePreChar}${value} dias`;
    },
  },
};

export type LabelTypes = keyof typeof labelTypesFormatted;
